import { ClearOutlined, PlusCircleOutlined, MinusCircleOutlined, CheckCircleOutlined } from '@ant-design/icons'
import { Alert, Col, Form, Input, Row, Select, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { msgType } from '../../../../types/msgType'

export const EditRctMcta = (props) => {
    const { monedas_sel, monedas_all: monedas, onTipoCta, onCxcCxp, setMonedas } = props

    const [formCta] = Form.useForm()
    const [fmTipoCta, setFmTipoCta] = useState(null)
    const [fmCtaCXC, setFmCtaCXC] = useState(null)
    const [fmCtaCXP, setFmCtaCXP] = useState(null)
    const [registros, setRegistros] = useState([])
    const [selRegistro, setSelRegistro] = useState(null)
    const [selMoneda, setSelMoneda] = useState(null)
    const [clearReg, setClearReg] = useState(false)
    const [confirmado, setConfirmado] = useState(true)
    const [messageApp, setMessageApp] = useState(null)

    useEffect(() => {
        const areg = monedas_sel?.map(p => ({ ...p, nombre: monedas?.find(q => q.codigo === p.monedaISO)?.nombre }))?.sort((a, b) => a.nombre > b.nombre ? 1 : -1)?.map((p, i) => getReg(p, i)) || []
        const sreg = areg.find(p => true) || null

        setRegistros(areg)
        setSelRegistro(sreg)
    }, [monedas_sel, monedas])

    useEffect(() => {
        const tipoCta = onTipoCta ? (selRegistro?.tipoCta || null) : null
        const ctaCXC = onCxcCxp ? (selRegistro?.tipoCta?.ctaCXC || null) : null
        const ctaCXP = onCxcCxp ? (selRegistro?.tipoCta?.ctaCXP || null) : null
        const moneda = monedas.find(p => p.codigo === selRegistro?.monedaISO)

        setFmTipoCta(tipoCta)
        setFmCtaCXC(ctaCXC)
        setFmCtaCXP(ctaCXP)
        setSelMoneda(moneda)
        setConfirmado(true)

        formCta.setFieldsValue({
            monedaISO: moneda?.codigo,
            tipoCta: tipoCta,
            ctaCXC: ctaCXC,
            ctaCXP: ctaCXP,
        })
        // eslint-disable-next-line
    }, [selRegistro, monedas, onTipoCta, onCxcCxp, clearReg, formCta])

    const getReg = (reg, index) => {
        var nreg = { ...reg, key: index, label: `${index + 1}: ${reg.nombre?.toUpperCase() ?? reg.monedaISO}` }
        return nreg
    }

    const sortData = (a, b) => {
        if (a.key > b.key)
            return 1
        else
            return -1
    }

    const showAlert = (msg) => {
        setMessageApp(msg)
        setTimeout(() => { setMessageApp(null) }, 5000)
    }

    const onValuesChangeCta = (changedValues, allValues) => {
        const monedaISO = allValues.monedaISO ?? null
        const tipoCta = allValues.tipoCta ?? null
        const ctaCXC = allValues?.ctaCXC || null
        const ctaCXP = allValues?.ctaCXP || null
        const moneda = monedas.find(mon => mon.codigo === monedaISO) || null

        setSelMoneda(moneda)
        setFmTipoCta(tipoCta)
        setFmCtaCXC(ctaCXC)
        setFmCtaCXP(ctaCXP)
        setConfirmado(false)
    }

    const handleChangeRegistro = (value, areg) => {
        const sreg = areg.find(p => p.key === value) || null
        setSelRegistro(sreg)
    }

    const handleAgregarRegistro = () => {
        let err = null

        if (!selMoneda)
            err = {
                message: `${msgType.registroNoField} moneda.`,
                oops: false
            }
        else if (registros.find(p => p.monedaISO === selMoneda.codigo && (!selRegistro || selRegistro.key !== p.key)))
            err = {
                message: `${msgType.rpDataMoneda}`,
                oops: false
            }
        else if (onCxcCxp && (!fmCtaCXC || fmCtaCXC.trim() === '') && fmCtaCXP && fmCtaCXP.trim() !== '')
            err = {
                message: `${msgType.registroNoField} cuenta por cobrar.`,
                oops: false
            }
        else if (onCxcCxp && (!fmCtaCXP || fmCtaCXP.trim() === '') && fmCtaCXC && fmCtaCXC.trim() !== '')
            err = {
                message: `${msgType.registroNoField} cuenta por cobrar.`,
                oops: false
            }

        if (err) {
            showAlert(err.message)
            return
        }

        let maxKey = selRegistro ? selRegistro.key : (registros.length > 0 ? Math.max.apply(null, registros.map(p => p.key)) + 1 : 0)
        const sreg = getReg({
            monedaISO: selMoneda?.codigo,
            nombre: selMoneda?.nombre,
            tipoCta: onCxcCxp ? ((fmCtaCXC || fmCtaCXP) ? { ctaCXC: fmCtaCXC, ctaCXP: fmCtaCXP } : null) : (onTipoCta ? (fmTipoCta && fmTipoCta.trim().length !== 0 ? fmTipoCta.trim() : null) : null),
        }, maxKey)
        setRegistros(prev => {
            const areg = selRegistro ? prev.filter(p => p.key !== selRegistro.key) : prev.filter(p => true)
            const nreg = [...areg, sreg]
            nreg.sort(sortData)
            return nreg
        })
        setSelRegistro(sreg)
        setConfirmado(true)
    }

    const handleQuitarRegistro = () => {
        if (selRegistro) {
            const areg = registros.filter(p => p.key !== selRegistro.key)
            const sreg = areg.find(p => true) || null
            setRegistros(areg)
            setSelRegistro(sreg)
        }
    }

    const handleConfirmar = () => {
        let err = null

        if (!confirmado)
            err = {
                message: msgType.noConfimGrupo,
                oops: false
            }

        if (err) {
            showAlert(err.message)
            return
        }

        const nmonedas = registros.map(p => ({ monedaISO: p.monedaISO, tipoCta: p.tipoCta }))
        if (setMonedas)
            setMonedas(nmonedas)
    }

    return (
        <div className='flex flex-col ant-common-titania'>
            <div>
                <div className='mb-1'>
                    <span>Lista de monedas</span>
                </div>
                <div className='flex space-x-2'>
                    <Select placeholder='Nuevo registro' style={{ width: 280 }} value={selRegistro?.key}
                        onChange={(v) => handleChangeRegistro(v, registros)} allowClear>
                        {
                            registros.map(({ key, label }) => (
                                <Select.Option key={key} value={key}>{label}</Select.Option>
                            ))
                        }
                    </Select>
                    {
                        !selRegistro &&
                        <Tooltip title="Limpiar registro" placement='top'>
                            <button onClick={() => setClearReg(prev => !prev)} className='flex items-center'>
                                <ClearOutlined className='text-gray-700' style={{ fontSize: '0.9rem' }} />
                            </button>
                        </Tooltip>
                    }
                    {
                        (!selRegistro && !confirmado) &&
                        <Tooltip title="Nuevo registro" placement='top'>
                            <button onClick={handleAgregarRegistro} className='flex items-center'>
                                <PlusCircleOutlined className='text-green-700' style={{ fontSize: '0.9rem' }} />
                            </button>
                        </Tooltip>
                    }
                    {
                        (selRegistro && !confirmado) &&
                        <Tooltip title="Modificar registro" placement='top'>
                            <button onClick={handleAgregarRegistro} className='flex items-center'>
                                <CheckCircleOutlined className='text-blue-700' style={{ fontSize: '0.9rem' }} />
                            </button>
                        </Tooltip>
                    }
                    {
                        (selRegistro && confirmado) &&
                        <Tooltip title="Quitar registro" placement='top'>
                            <button onClick={handleQuitarRegistro} className='flex items-center'>
                                <MinusCircleOutlined className='text-red-700' style={{ fontSize: '0.9rem' }} />
                            </button>
                        </Tooltip>
                    }
                    {
                        !confirmado &&
                        <div className='flex items-center justify-center'>
                            <span className='text-yellow-700 text-[0.6rem]'>[ Sin confirmar ]</span>
                        </div>
                    }
                </div>
            </div>
            <div className='ant-form-titania'>
                <Form
                    className='mt-3'
                    layout="vertical" requiredMark
                    onValuesChange={onValuesChangeCta}
                    autoComplete="off"
                    form={formCta}>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="monedaISO"
                                label="Moneda"
                                rules={[
                                    {
                                        required: true,
                                        message: '',
                                    },
                                ]}
                            >
                                <Select placeholder="Seleccione moneda"
                                    allowClear>
                                    {
                                        monedas.map(({ codigo, nombre }) => (
                                            <Select.Option key={codigo} value={codigo}>{nombre}</Select.Option>
                                        ))
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16} hidden={!onTipoCta}>
                        <Col span={12}>
                            <Form.Item
                                name="tipoCta"
                                label="Cuenta contable"
                                rules={[
                                    {
                                        required: false,
                                        message: '',
                                    },
                                ]}
                            >
                                <Input
                                    placeholder='Ingrese cuenta contable'
                                    size='middle'
                                    maxLength={25}
                                    style={{
                                        width: '100%',
                                    }} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16} hidden={!onCxcCxp}>
                        <Col span={12}>
                            <Form.Item
                                name="ctaCXC"
                                label="Cuenta por cobrar"
                                rules={[
                                    {
                                        required: false,
                                        message: '',
                                    },
                                ]}
                            >
                                <Input
                                    placeholder='Ingrese número de cuenta'
                                    size='middle'
                                    maxLength={25}
                                    style={{
                                        width: '100%',
                                    }} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="ctaCXP"
                                label="Cuenta por pagar"
                                rules={[
                                    {
                                        required: false,
                                        message: '',
                                    },
                                ]}
                            >
                                <Input
                                    placeholder='Ingrese número de cuenta'
                                    size='middle'
                                    maxLength={15}
                                    style={{
                                        width: '100%',
                                    }} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div className="flex flex-row flex-wrap space-x-3 mt-3">
                <div className="flex items-center text-[0.8rem] text-indigo-700">
                    <div className='flex items-center cursor-pointer'
                        onClick={handleConfirmar}>
                        <Tooltip title={"Aceptar configuración"} placement='right'>
                            <CheckCircleOutlined className="mr-1.5 text-gray-600" aria-hidden="true" />
                        </Tooltip>
                        Aceptar
                    </div>
                </div>
            </div>
            {
                messageApp &&
                <div className='mt-4'>
                    <Alert className='text-xs' message={messageApp} type="warning" showIcon closable afterClose={() => setMessageApp(null)} />
                </div>
            }
        </div>
    )
}
